import React from 'react';
import { useTranslation } from 'react-i18next';
import Link from '@websky/core/src/Link';
import { getLocale } from '@websky/core/src/utils';
import { useConfig } from '@websky/core/src/context';
import { Locale } from '@websky/core/src/types';
import InfoLinksLabelComponent from '@websky/core/src/InfoLinksLabel/components/InfoLinksLabel';
const InfoLinksLabel = props => {
    const { t } = useTranslation('Checkout');
    const companyInfo = useConfig().global.companyInfo;
    const locale = getLocale();
    const currentLocale = locale === Locale.Russian ? '' : `${locale}/`;
    const covidLink = `https://www.flyaurora.ru/${currentLocale}information/passengers/covid-19/`;
    return (React.createElement(InfoLinksLabelComponent, Object.assign({}, props, { checkoutLabel: React.createElement("span", null,
            t('I accept the'),
            ' ',
            React.createElement(Link, { target: "_blank", action: companyInfo.legal }, t('terms of agreement')),
            ", ",
            t('authorize the processing and storage of personal data'),
            ".",
            ' ',
            React.createElement(Link, { target: "_blank", action: covidLink }, t('I have read the entry restrictions due to COVID'))) })));
};
export default InfoLinksLabel;
